export default __webpack_public_path__ + "static/media/footer.87283115.png";